import { Dispatch, SetStateAction, MouseEvent } from "react";
import { ReactComponent as PrevIcon } from '../../assets/Icons/chevron/Chevron-Left.svg';
import { ReactComponent as NextIcon } from '../../assets/Icons/chevron/Chevron-Right.svg';

export default function ImageToggle({
    selectedIndex,
    setSelectedIndex,
    totalIndices,
}: {
    selectedIndex: number,
    setSelectedIndex: Dispatch<SetStateAction<number>>,
    totalIndices: number,
}) {

    const next = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setSelectedIndex(selectedIndex + 1);
    }

    const previous = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setSelectedIndex(selectedIndex - 1);
    }

    return (
        <div className="flex justify-center items-center gap-1">
            <button 
                disabled={selectedIndex === 0}
                onClick={previous}
                className={`${selectedIndex === 0 ? 'bg-none hover:brightness-100' : 'bg-secondary hover:brightness-90'} transition-all border border-secondary text-primary p-1 aspect-square flex justify-center items-center rounded-lg`}
            >
                <div className="w-[16px]"><PrevIcon/></div>
            </button>
            <button 
                disabled={selectedIndex === totalIndices-1}
                onClick={next}
                className={`${selectedIndex === totalIndices-1 ? 'bg-none hover:brightness-100' : 'bg-secondary hover:brightness-90'} transition-all border border-secondary text-primary p-1 aspect-square flex justify-center items-center rounded-lg`}
            >
                <div className="w-[16px]"><NextIcon/></div>
            </button>
        </div>
    )
}